import { Box, Button, Flex, Heading, Image, Input, Stack, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { CLIENT_CONFIG } from '../core/client/buildConfig'
import microsoftLogo from '../assets/static/images/microsoft.png'
import { useAuth } from '../context/AuthContext'
import { useLanguage } from '../hooks/utility/useLanguage'

const LoginPage: React.FC = () => {
  const { signIn, signInWithPassword } = useAuth()
  const { t } = useLanguage()
  const [showPasswordForm, setShowPasswordForm] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const handlePasswordLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)
    try {
      await signInWithPassword(username, password)
    } catch (err: any) {
      setError(err.message || 'Login failed')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Flex
      flexDirection='column'
      width='100wh'
      height='100vh'
      bgImage={
        CLIENT_CONFIG.theme.branding.backgroundImage
          ? `url(${CLIENT_CONFIG.theme.branding.backgroundImage})`
          : undefined
      }
      bg={!CLIENT_CONFIG.theme.branding.backgroundImage ? CLIENT_CONFIG.theme.colors.primary : undefined}
      bgSize='cover'
      bgPosition='center'
      bgRepeat='no-repeat'
      overflow='hidden'
      justifyContent='center'
      alignItems='center'
    >
      <Stack flexDir='column' mb='2' justifyContent='center' alignItems='center'>
        <Heading color='white'>{t('auth.welcomeTester')}</Heading>
        <Box width={{ base: '80%', md: '400px' }} p={6}>
          <Stack spacing={4} p='1rem' bg='E3D7CA'>
            <Flex align='center' gap={10}>
              <Box textAlign='center'>
                <Text color='white'>Welkom bij {CLIENT_CONFIG.theme.branding.companyName}!</Text>
                <Text color='white'>{t('auth.loginInstructions')}</Text>
              </Box>
            </Flex>

            <Button
              leftIcon={<Image src={microsoftLogo} alt='Microsoft logo' boxSize='24px' />}
              borderRadius={0}
              variant='solid'
              bgColor='gray.100'
              fontSize='20px'
              width='full'
              onClick={signIn}
              color='white'
              bg='secondary'
              _hover={{
                bg: 'white',
                color: 'secondary',
                border: '1px solid',
                borderColor: 'secondary',
              }}
            >
              {t('auth.loginWithMicrosoft')}
            </Button>

            <Text
              fontSize='sm'
              textAlign='center'
              cursor='pointer'
              textDecoration='underline'
              onClick={() => setShowPasswordForm(!showPasswordForm)}
              color='white'
              _hover={{ color: 'gray.300' }}
            >
              {showPasswordForm ? 'Hide' : 'Login with username and password'}
            </Text>

            {showPasswordForm && (
              <Box as='form' onSubmit={handlePasswordLogin} mt={4}>
                <Stack spacing={3}>
                  <Input
                    placeholder='Username'
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    required
                    bg='white'
                  />
                  <Input
                    type='password'
                    placeholder='Password'
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    bg='white'
                  />
                  {error && (
                    <Text color='red.500' fontSize='sm'>
                      {error}
                    </Text>
                  )}
                  <Button
                    type='submit'
                    width='full'
                    isLoading={isLoading}
                    bg='secondary'
                    color='white'
                    _hover={{
                      bg: 'white',
                      color: 'secondary',
                      border: '1px solid',
                      borderColor: 'secondary',
                    }}
                  >
                    Login
                  </Button>
                </Stack>
              </Box>
            )}
          </Stack>
        </Box>
      </Stack>
    </Flex>
  )
}

export default LoginPage
